import BaseAPI from "../../../baseAPI";

class CheckoutAPI extends BaseAPI {
  constructor() {
    super("/store/transaction/checkout")
  }

  getExpeditionList() {
    return this.get("/shipping", true)
  }

  processSnapToken(data) {
    return this.post(`/get-snap-token`, data, true)
  }

  processMidtransCallback(query) {
    return this.post(`/midtrans-callback`, query, true)
  }
}

export { CheckoutAPI as default }